import React, {useEffect, useState} from 'react';
import {
    FaCalendarCheck,
    FaCar,
    FaClipboardList,
    FaMoneyBillWave,
    FaTools,
    FaUsers,
    FaUserTie,
    FaWrench
} from 'react-icons/fa';
import {getCustomerCount, getEmployeeCount, getMetricsByWorkshopId} from '../../Api/Api';
import {useWorkshop} from "../Common/WorkshopContext";
import {useNotification} from "../Notification/NotificationContext";
import WorkshopLoadChart from "./WorkshopLoadChart";
import ReportDashboard from "./Report/ReportDashboard";

const WorkshopDashboard = () => {
    const [employeeCount, setEmployeeCount] = useState(0);
    const [customerCount, setCustomerCount] = useState(0);
    const [metrics, setMetrics] = useState(null);
    const { workshopId } = useWorkshop();
    const { showNotification } = useNotification();

    useEffect(() => {
        // Fetch count of employees and customers for this workshop
        getEmployeeCount(workshopId)
            .then((response) => {
                setEmployeeCount(response.data.count);
            })
            .catch((error) => {
                 showNotification(error.message, "error")
            });

        getCustomerCount(workshopId)
            .then((response) => {
                setCustomerCount(response.data.count);
            })
            .catch((error) => {
                 showNotification(error.message, "error")
            });
    }, [workshopId]);



    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                getMetricsByWorkshopId(workshopId)
                    .then((res) => {
                        setMetrics(res.data);
                    })
                    .catch((error) => {
                         showNotification(error.message, "error")
                    });
            } catch (error) {
                 showNotification(error.message, "error")
            }
        };

        fetchMetrics();
    }, []);

    const statCards = [
        {
            title: "Total Employees",
            value: employeeCount,
            icon: <FaUserTie className="text-blue-500 text-2xl" />
        },
        {
            title: "Total Customers",
            value: customerCount,
            icon: <FaUsers className="text-green-500 text-2xl" />
        },
        {
            title: "Job Cards Created",
            value: metrics?.yearlyCompletedJobCards + metrics?.inProgressJobCards,
            icon: <FaClipboardList className="text-purple-500 text-2xl" />
        },
        {
            title: "Job Cards Completed",
            value: metrics?.yearlyCompletedJobCards,
            icon: <FaCalendarCheck className="text-teal-500 text-2xl" />
        },
        // {
        //     title: "Vehicles Serviced",
        //     value: metrics.totalVehiclesServiced,
        //     icon: <FaCar className="text-indigo-500 text-2xl" />
        // },
        {
            title: "Workshop Revenue",
            value: `₹${metrics?.totalRevenue?.toLocaleString() || 0}`,
            icon: <FaMoneyBillWave className="text-green-600 text-2xl" />
        },
        {
            title: "Assets Assigned",
            value: metrics?.totalAssetsAssigned,
            icon: <FaTools className="text-yellow-500 text-2xl" />
        },
        {
            title: "Open Job Cards",
            value: metrics?.inProgressJobCards,
            icon: <FaWrench className="text-red-500 text-2xl" />
        }
    ];


    return (
        <div className="max-w-screen-xl mx-auto mt-6">
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="bg-teal-500 text-white p-4 rounded-t-lg">
                    <h2 className="text-2xl font-semibold text-center">Workshop Dashboard</h2>
                </div>

                {/* Metric Cards */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {statCards.map((metric, index) => (
                        <div key={index} className="bg-white shadow-md p-4 rounded-lg flex items-center">
                            {metric.icon}
                            <div className="ml-3">
                                <p className="text-gray-600 text-sm">{metric.title}</p>
                                <p className="text-lg font-semibold text-teal-600">{metric.value}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Optional Chart Section */}
                <div className="p-6">
                    <WorkshopLoadChart workshopId={workshopId} />
                </div>
                <div className="p-6">
                    <ReportDashboard/>
                </div>
            </div>
        </div>
    );
};

export default WorkshopDashboard;
